import objectUtils from '../utils/object-utils'

export default class User {
  constructor (options = {}) {
    this.model = 'User'
    this.is_logged_in = true

    // ID and authentication info
    this.id = objectUtils.get(options, 'id', null)
    this.thirdparty_id = objectUtils.get(options, 'thirdparty_id', null)
    this.thirdparty_system = objectUtils.get(options, 'thirdparty_system', null)

    // General user identification
    this.email = objectUtils.get(options, 'email', null)
    this.phone_number = objectUtils.get(options, 'phone_number', null)
    this.first_name = objectUtils.get(options, 'first_name', null)
    this.middle_name = objectUtils.get(options, 'middle_name', null)
    this.last_name = objectUtils.get(options, 'last_name', null)
    this.display_name = objectUtils.get(options, 'display_name', null)
    this.avatar_url = objectUtils.get(options, 'avatar_url', null)
    this.avatar_thumb_url = options.avatar_thumb_url

    // User settings and status
    this.default_locale = objectUtils.get(options, 'default_locale', null)
    this.default_timezone = objectUtils.get(options, 'default_timezone', null)
    this.settings = (options.settings && !options.settings.isEmpty) ? options.settings : {}
    this.user_status = objectUtils.get(options, 'user_status', null)
    this.is_driver = objectUtils.get(options, 'is_driver', false)
    this.saved_signature = options.saved_signature

    // Drivers license info
    this.drivers_license_number = objectUtils.get(options, 'drivers_license_number', null)
    this.drivers_license_state_code = objectUtils.get(options, 'drivers_license_state_code', null)
    this.drivers_license_issue_date = objectUtils.get(options, 'drivers_license_issue_date', null)
    this.drivers_license_expiration = objectUtils.get(options, 'drivers_license_expiration', null)
    this.saved_drivers_license = objectUtils.get(options, 'saved_drivers_license', false)

    // FA license info
    this.fa_license_number = objectUtils.get(options, 'fa_license_number', null)
    this.fa_license_state_code = objectUtils.get(options, 'fa_license_state_code', null)
    this.fa_license_issue_date = objectUtils.get(options, 'fa_license_issue_date', null)
    this.fa_license_expiration = objectUtils.get(options, 'fa_license_expiration', null)
    this.saved_fa_license = objectUtils.get(options, 'saved_fa_license', false)

    // Sign-up provided info
    this.requested_role = objectUtils.get(options, 'requested_role', null)
    this.brand_name = objectUtils.get(options, 'brand_name', null)

    // Active org context
    this.active_org_id = objectUtils.get(options, 'active_org_id', null)

    // All roles (system roles + active org roles)
    // These are flattened roles per the active org context for programmatic convenience.
    // NOTE: To inspect the role metadata, access the "org_membership_info" association.
    this.roles = objectUtils.get(options, 'roles', [])

    // Auditing
    this.last_login_at = objectUtils.get(options, 'last_login_at', null)
    this.approved_at = objectUtils.get(options, 'approved_at', null)
    this.flagged_at = objectUtils.get(options, 'flagged_at', null)
    this.deactivated_at = objectUtils.get(options, 'deactivated_at', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.info) this.info = options.info
    if (options.driver_info) this.driver_info = options.driver_info
    if (options.active_org) this.active_org = options.active_org
    if (options.org_membership_info) this.org_membership_info = options.org_membership_info
    if (options.org_memberships) this.org_memberships = options.org_memberships
  }
}
